import axios from "../axios-auth";

export const financeSettingService = {
    getAllFinanceSettingList,
    saveFinanceSetting,
    getFinanceSettingDetail,
    getAllFinanceSetting
}

function getAllFinanceSettingList(searchParams, page, size, sortBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    } if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortBy
    };
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.financialYearName) {
        params["financialYearName"] = searchParams.financialYearName;
    }
    return axios.get("/auth/finance-setting", { params })
}

function saveFinanceSetting(financeSetting) {
    if (!financeSetting.id) {
        // new finance session
        return axios.post("/auth/finance-setting", financeSetting);
    } else {
        // edit
        return axios.put("/auth/finance-setting", financeSetting);

    }
}

function getFinanceSettingDetail(id) {
    return axios.get("/auth/finance-setting/" + id);
}

function getAllFinanceSetting() {
    return axios.get("/auth/finance-setting");
}
